module.exports = __webpack_public_path__ + "static/img/014.78b0cf3d.png";